<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <fieldset style="width: 100% !important">
            <legend>
              <div>
                <input
                  type="radio"
                  name="rbFilterRights"
                  id="rbRole"
                  value="1"
                  v-model="rbFilterRights"
                  v-on:click="changeFilters(1)"
                />
                <label for="rbRole">Role</label>
                <input
                  type="radio"
                  name="rbFilterRights"
                  id="rbUser"
                  value="2"
                  v-model="rbFilterRights"
                  v-on:click="changeFilters(2)"
                />
                <label for="rbUser">User</label>
                <!-- <input
                  type="radio"
                  name="rbFilterRights"
                  id="rbRole"
                  value="1"
                  v-on:click="changeFilters(1)"
                />
                <label for="rbRole">Role</label>
                <input
                  type="radio"
                  name="rbFilterRights"
                  id="rbUser"
                  value="2"
                  v-on:click="changeFilters(2)"
                />
                <label for="rbUser">User</label> -->
              </div>
            </legend>
            <div class="Flex_Table tblEntryForm">
              <div class="Flex_Row">
                <div class="Flex_Cell_Inline">
                  <span class="mandatorySpan" :class="{ Required: false }">
                    Module &nbsp;
                  </span>
                  <select id="ddlUserType" v-model="moduleID">
                    <option value="-1">---Select---</option>
                    <option
                      v-for="m in module_List"
                      :key="m.moduleID"
                      v-bind:value="m.moduleID"
                    >
                      {{ m.moduleName }}
                    </option>
                  </select>
                </div>
                <div class="Flex_Cell_Inline" v-if="moduleID != -1">
                  <span class="mandatorySpan" :class="{ Required: false }">
                    Role &nbsp;
                  </span>
                  <select
                    v-if="rbFilterRights == 1"
                    id="ddlUserType"
                    v-model="roleID"
                    @change="getFormRights()"
                  >
                    <option value="-1">---Select---</option>
                    <option
                      v-for="r in role_List"
                      :key="r[0]"
                      v-bind:value="r[0]"
                    >
                      {{ r[1] }}
                    </option>
                  </select>
                  <select
                    v-if="rbFilterRights == 2"
                    id="ddlUserType"
                    v-model="roleID"
                    @change="getUserList()"
                  >
                    <option value="-1">---Select---</option>
                    <option
                      v-for="r in role_List"
                      :key="r[0]"
                      v-bind:value="r[0]"
                    >
                      {{ r[1] }}
                    </option>
                  </select>
                </div>
                <div
                  class="Flex_Cell_Inline"
                  v-if="roleID != -1 && rbFilterRights == 2"
                >
                  <span class="mandatorySpan" :class="{ Required: false }">
                    <!-- <span
                      ><input
                        type="checkbox"
                        v-model="isDeleted"
                        :id="'isDeleted'"
                        @change="getUserList()"
                      />
                      <label :for="'isDeleted'">Active User</label></span
                    > -->
                    User
                  </span>
                  <select
                    id="ddlUserType"
                    v-model="userID"
                    @change="getFormRights()"
                  >
                    <option value="-1">---Select---</option>
                    <option
                      v-for="u in user_List"
                      :key="u.userID"
                      v-bind:value="u.userID"
                    >
                      {{ u.userName }}
                    </option>
                  </select>
                </div>
                <div class="Flex_Cell_Inline" valign="bottom">
                  <input
                    type="button"
                    value="Get Rights"
                    style="padding: 5px"
                    title="Click to SaveProfile"
                    @click="getFormRights()"
                  />
                </div>
              </div>
              <div
                class="Flex_Table"
                v-if="
                  (rbFilterRights == 1 && formRights_List.length > 0) ||
                  (rbFilterRights == 2 && formRights_List.length > 0)
                "
              >
                <div class="Flex_Row">
                  <div class="Flex_Cell">
                    <legend
                      v-if="rbFilterRights == 1 && formRights_List.length > 0"
                    >
                      Form Rights
                    </legend>
                    <legend
                      v-if="rbFilterRights == 2 && formRights_List.length > 0"
                    >
                      User Rights
                    </legend>
                    <div>
                      <div
                        class="Flex_Table ekkGrid wrapText"
                        style="width: 100%"
                        v-if="formRights_List.length > 0"
                        id="dvformRightsTable"
                      >
                        <div class="Flex_Row GridHeader" valign="middle">
                          <div class="Flex_Cell">
                            {{ formRights_List[0].formName }}
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl1 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl1
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl2 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl2
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl3 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl3
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl4 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl4
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl5 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl5
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl6 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl6
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl7 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl7
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl8 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl8
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl9 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl9
                            }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 9%"
                            v-if="formRights_List[0].cOl10 != 'X'"
                          >
                            <input
                              type="checkbox"
                              title="Select All"
                              v-on:click="checkAll($event.target, 'cOlValue1')"
                            />
                            <span style="margin-left: 5px">{{
                              formRights_List[0].cOl10
                            }}</span>
                          </div>
                        </div>
                        <div
                          class="Flex_Row GridContent"
                          v-for="(row, index) in formRights_List.filter((r) => {
                            return r.rowID == 1;
                          })"
                          :key="index"
                        >
                          <div class="Flex_Cell">
                            {{ row.formName }}
                          </div>
                          <div
                            class="Flex_Cell"
                            align="center"
                            v-if="row.cOl1 != 'X'"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl1 != ''"
                              v-model="row.cOlValue1"
                              @change="
                                SelectRight($event.target, row.cOlValue1)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            align="center"
                            v-if="row.cOl2 != 'X'"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl2 != ''"
                              v-model="row.cOlValue2"
                              @change="
                                SelectRight($event.target, row.cOlValue2)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl3 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl3 != ''"
                              v-model="row.cOlValue3"
                              @change="
                                SelectRight($event.target, row.cOlValue3)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl4 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl4 != ''"
                              v-model="row.cOlValue4"
                              @change="
                                SelectRight($event.target, row.cOlValue4)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl5 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl5 != ''"
                              v-model="row.cOlValue5"
                              @change="
                                SelectRight($event.target, row.cOlValue5)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl6 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl6 != ''"
                              v-model="row.cOlValue6"
                              @change="
                                SelectRight($event.target, row.cOlValue6)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl7 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl7 != ''"
                              v-model="row.cOlValue7"
                              @change="
                                SelectRight($event.target, row.cOlValue7)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl8 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl8 != ''"
                              v-model="row.cOlValue8"
                              @change="
                                SelectRight($event.target, row.cOlValue8)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl9 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl9 != ''"
                              v-model="row.cOlValue9"
                              @change="
                                SelectRight($event.target, row.cOlValue9)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            v-if="row.cOl10 != 'X'"
                            align="center"
                            style="width: 9%"
                          >
                            <input
                              type="checkbox"
                              v-if="row.cOl10 != ''"
                              v-model="row.cOlValue10"
                              @change="
                                SelectRight($event.target, row.cOlValue10)
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Flex_Row">
                  <div class="Flex_Cell" align="center">
                    <input
                      type="button"
                      value="Save Rights"
                      style="padding: 5px"
                      title="Click to SaveProfile"
                      @click="saveFormRights()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue from "vue";
import UserManagementJS from "./servicesJS/UserManagement.js";
import MasterEntryJS from "./servicesJS/MasterEntry.js";

export default {
  name: "UserManagement",
  data() {
    return {
      selectTab1: true,
      selectTab2: false,
      selectTab3: false,
      role_List: [],
      roleID: -1,
      rbFilterRights: "1",
      userID: -1,
      user_List: [],
      formRights_List: [],
      form_List: [],
      moduleID: -1,
      module_List: [],
      isDeleted: true,
      isDeletedInt: 0,
    };
  },
  methods: {
    getRole() {
      this.role_List = [];
      const _data_ = { isActive: 1, type: 4 };
      MasterEntryJS.getUserType(_data_).then(
        (response) => {
          this.role_List = response.data;
        },
        (error) => {},
        (failure) => {}
      );
    },
    getModule() {
      this.module_List = [];
      const _data_ = { moduleID: -1, isActive: 1, type: 1 };
      UserManagementJS.getModule(_data_).then(
        (response) => {
          this.module_List = response.data;
        },
        (error) => {},
        (failure) => {}
      );
    },
    getUserList() {
      this.user_List = [];
      this.formRights_List = [];
      if (this.isDeleted) {
        this.isDeletedint = 0;
      } else {
        this.isDeletedint = 1;
      }
      const _data_ = {
        userTypeID: this.roleID,
        fromDate: new Date("01 Jan 1900"),
        toDate: new Date("01 Jan 1900"),
        isDeleted: this.isDeletedint,
        type: 1,
      };
      UserManagementJS.getUserList(_data_).then(
        (response) => {
          this.user_List = response.data;
          this.userID = -1;
        },
        (error) => {},
        (failure) => {}
      );
    },
    getFormRights() {
      this.formRights_List = [];
      let type;
      if (this.rbFilterRights == "1") {
        if (this.roleID == -1) {
          MessageBox.show({
            message: "Please select role",
            type: "error",
            title: "Error",
          });
          return false;
        }
        type = 1;
      }
      if (this.rbFilterRights == "2") {
        if (this.userID == "-1") {
          MessageBox.show({
            message: "Please select user",
            type: "error",
            title: "Error",
          });
          return false;
        }
        type = 2;
      }
      const _data_ = {
        moduleID: this.moduleID,
        userTypeID: this.roleID,
        userID: this.userID,
        type: type,
      };
      UserManagementJS.getUserRights(_data_).then(
        (response) => {
          this.formRights_List = response.data.result;
          //   this.form_List = this.formRights_List.filter((obj) => {
          //     return obj.rowID == 1;
          //   });
          // console.log(this.formRights_List);
        },
        (error) => {},
        (failure) => {}
      );
    },
    changeFilters(filterType) {
      this.moduleID = -1;
      this.roleID = -1;
      this.userID = -1;
      this.rbFilterRights = filterType;
      this.formRights_List = [];
      this.getUserType();
    },

    saveFormRights() {
      let saveFormRights = new Object();
      saveFormRights.ModuleID = this.moduleID;
      saveFormRights.RoleID = this.roleID;
      saveFormRights.RoleUserID = this.userID;
      if (this.rbFilterRights == "1") {
        saveFormRights.Type = 1;
        saveFormRights.ModuleName = "";
        // this.modules.forEach((r) => {
        //   if (r.mModuleID == this.moduleID) {
        //     saveFormRights.ModuleName = r.mModuleName;
        //   }
        // });
        saveFormRights.BoardTypeName = "";
        // this.boardTypeList.forEach((r) => {
        //   if (r.boardTypeID == this.boardTypeID) {
        //     saveFormRights.BoardTypeName = r.boardTypeName;
        //   }
        // });
        saveFormRights.RoleName = "";
        // this.roleList.forEach((r) => {
        //   if (r.roleID == this.roleID) {
        //     saveFormRights.RoleName = r.roleName;
        //   }
        // });
      }
      if (this.rbFilterRights == "2") {
        saveFormRights.Type = 2;
        saveFormRights.RoleUserName = this.userName;
      }
      if (this.moduleID == -1) {
        MessageBox.show({
          message: "Please select module",
          type: "info",
          title: "API says",
        });
        return false;
      }
      // if (this.roleID == -1) {
      //   MessageBox.show({
      //     message: "Please select role",
      //     type: "error",
      //     title: "Error",
      //   });
      //   return false;
      // }
      if (this.formRights_List == null) {
        MessageBox.show({
          message: "No data found for save form rights.",
          type: "error",
          title: "Error",
        });
        return false;
      }
      saveFormRights.FormData = this.formRights_List.filter((obj) => {
        return obj.rowID == 1;
      });

      //console.log(saveFormRights.FormData);
      var formData = new FormData();
      formData.append("FormRightsData", JSON.stringify(saveFormRights));
      UserManagementJS.addUserRights(formData).then(
        (result) => {
          MessageBox.show({
            message: result.data.msg,
            type: "success",
            title: "Success",
          });
          if (result.data.isSuccess) {
            this.getFormRights();
          }
        },
        (error) => {},
        (failure) => {}
      );
    },
    checkAll(obj, columnFlag) {
      let dataForChecks = this.formRights_List.filter((obj) => {
        return obj.rowID == 1;
      });
      dataForChecks.forEach((element) => {
        element[columnFlag] = obj.checked;
      });
    },
    SelectRight(obj, colValue) {
      this.formRights_List
        .filter((obj1) => {
          return obj1.rowID == 1;
        })
        .forEach((element) => {
          if (element.cOlValue1 == colValue) {
            if (obj.checked == true) {
              element.cOlValue1 = true;
            } else {
              element.cOlValue1 = false;
            }
          }
          if (element.cOl2 == colID) {
            if (obj.checked == true) {
              element.cOlValue2 = true;
            } else {
              element.cOlValue2 = false;
            }
          }
          if (element.cOl3 == colID) {
            if (obj.checked == true) {
              element.cOlValue3 = true;
            } else {
              element.cOlValue3 = false;
            }
          }
          if (element.cOl4 == colID) {
            if (obj.checked == true) {
              element.cOlValue4 = true;
            } else {
              element.cOlValue4 = false;
            }
          }
          if (element.cOl5 == colID) {
            if (obj.checked == true) {
              element.cOlValue5 = true;
            } else {
              element.cOlValue5 = false;
            }
          }
          if (element.cOl6 == colID) {
            if (obj.checked == true) {
              element.cOlValue6 = true;
            } else {
              element.cOlValue6 = false;
            }
          }
          if (element.cOl7 == colID) {
            if (obj.checked == true) {
              element.cOlValue7 = true;
            } else {
              element.cOlValue7 = false;
            }
          }
          if (element.cOl8 == colID) {
            if (obj.checked == true) {
              element.cOlValue8 = true;
            } else {
              element.cOlValueID8 = false;
            }
          }
          if (element.cOl9 == colID) {
            if (obj.checked == true) {
              element.cOlValue9 = true;
            } else {
              element.cOlValue9 = false;
            }
          }
          if (element.cOl10 == colID) {
            if (obj.checked == true) {
              element.cOlValue10 = true;
            } else {
              element.cOlValue10 = false;
            }
          }
        });
    },
  },
  mounted() {
    this.getRole();
    // this.getUserList();
    this.getModule();
  },
};
</script>
<style scoped>
.wrapText {
  overflow-wrap: anywhere;
}
#background {
  background: url("../assets/images/logoa.png");
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UserAndFormRights.vue